import { action, thunk } from 'easy-peasy';
import filters from 'store/catalog/filters';
import utils from 'store/utils';
import moment from 'moment';

export default {
	loading: false,
	setLoading: action((state, payload) => {
		state.loading = payload;
	}),
	items: [],
	save: action((state, payload) => {
		state.items = payload.map(item => ({
			...item,
			expirationDate: moment(item.expirationDate, 'DD/MM/YYYY'),
			originalDate: item.expirationDate,
			isSelected: false,
			depotNew: item.depot,
			quantityRequiredNew: item.quantityRequired
		}));
	}),
	saveNewDepot: action((state, payload) => {
		const { catalog, depot } = payload;
		state.items = state.items.map(item => ({
			...item,
			depotNew: item.catalog == catalog ? depot : item.depotNew
		}));
	}),
	saveNewQuantity: action((state, payload) => {
		const { catalog, quantty } = payload;
		state.items = state.items.map(item => ({
			...item,
			quantityRequiredNew: item.catalog == catalog ? quantty : item.quantityRequiredNew
		}));
	}),
	filters: {
		token: '',
		depots: []
	},
	setToken: action((state, payload) => {
		state.filters.token = payload.toLowerCase();
	}),
	selectDepotsValue: [],
	setSelectDepotsValue: action((state, payload) => {
		state.selectDepotsValue = payload;
	}),
	toggleDepot: action((state, payload) => {
		const i = state.filters.depots.findIndex(item => item === payload);
		if (i === -1) state.filters.depots.push(payload);
		else state.filters.depots.splice(i, 1);
	}),
	orderBy: 'expirationDate',
	orderDirection: 'desc',
	setOrder: action((state, payload) => {
		if (state.orderBy === payload) {
			state.orderDirection = state.orderDirection === 'asc' ? 'desc' : 'asc';
		} else {
			state.orderDirection = 'desc';
		}
		state.orderBy = payload;
	}),
	selectAll: action((state, payload) => {
		state.items = state.items.map(item => ({
			...item,
			isSelected: true
		}));
	}),
	deSelectAll: action((state, payload) => {
		state.items = state.items.map(item => ({
			...item,
			isSelected: false
		}));
	}),
	toggleSelection: action((state, payload) => {
		state.items = state.items.map(item => ({
			...item,
			isSelected: item.code === payload ? !item.isSelected : item.isSelected
		}));
	}),
	load: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		services.cart
			.getDeleted()
			.then(data => {
				actions.save(data.items);
			})
			.catch(e => {
				getStoreActions().error('order.deletedItemsLoad');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	})
};
